import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { BaseService } from "../../base.service";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class MagicLinkService extends BaseService {
  constructor(http: Http, cookieService: CookieService) {
    super(http, cookieService);
    this.init("magic-link-detail");
  }

  getDetail(magic_link) {
    let headers = new Headers();

    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", this.getAuthToken());
    let item = {
      magic_link: magic_link
    };

    return this.http
      .post(this.baseURL(), JSON.stringify(item), { headers: headers })
      .toPromise()
      .then(response => {
        return response.json();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/products/sales-presenters/magic_link.service.ts